module.exports = __webpack_public_path__ + "src/img/tv.ab5e6b92.svg";